import React from 'react';
import moment from 'moment';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import { useIntl } from 'react-intl';
import messages from './FieldMessages';
import RenderProperty from './RenderProperty';

const parseBoolean = value => {
  switch (value) {
    case true:
    case 'True':
    case 'true':
      return true;
    case false:
    case 'False':
    case 'false':
      return false;
    default:
      return null;
  }
};
const parseDate = value => {
  try {
    const mom = moment(value, 'M/D/YYYY h:mm A', true);

    if (!mom.isValid()) return null;

    return mom.format('LL');
  } catch (_) {
    return null;
  }
};
const FieldChange = props => {
  const intl = useIntl();
  const {
    log,
    users,
    relations,
    templates,
    ownCompanies,
    salutations,
    invoiceSchedules,
    priceGrids,
    invoiceStreams,
  } = props;

  const renderFieldValue = (value, property) => {
    if (property === 'VatNumber' && value === 'VatPending')
      return intl.formatMessage(messages.VatPending);
    if (property === 'Salutation' && value in (salutations || {}))
      return intl.formatMessage(listItemMsg('salutation', salutations[value].id));

    if (property === 'JurisdictionId' && value && !Number.isNaN(parseInt(value))) {
      return intl.formatMessage(listItemMsg('jurisdiction', value));
    }

    if (property === 'OtherSoftware') {
      // comma separated string
      if (!value) return '/';
      const otherSoftware = value
        .replace(/\s/g, '')
        .split(',')
        .filter(x => x !== '');
      if (otherSoftware.length === 0) return '/';
      return otherSoftware.map(x => intl.formatMessage(listItemMsg('othersoftware', x))).join(', ');
    }
    if (property === 'SendInvoiceSoftware') {
      // comma separated string
      if (!value) return '/';
      const sendInvoiceSoftware = value
        .replace(/\s/g, '')
        .split(',')
        .filter(x => x !== '');
      if (sendInvoiceSoftware.length === 0) return '/';
      return sendInvoiceSoftware
        .map(x => intl.formatMessage(listItemMsg('sendInvoiceSoftware', x)))
        .join(', ');
    }
    if (value in (users || {})) return users[value];
    if (value in (relations || {})) return relations[value];
    if (value in (ownCompanies || {})) return ownCompanies[value];
    if (value in (templates || {})) return templates[value];
    if (value in (invoiceSchedules || {})) return invoiceSchedules[value];
    if (value in (priceGrids || {})) return priceGrids[value];
    if (value in (invoiceStreams || {})) return invoiceStreams[value];

    const booleanValue = parseBoolean(value);
    if (booleanValue !== null)
      return booleanValue ? intl.formatMessage(messages.Yes) : intl.formatMessage(messages.No);

    const dateTimeFormat = parseDate(value);
    if (value !== null && dateTimeFormat !== null) return dateTimeFormat;

    return value ? value.toString() : '/';
  };

  return (
    <span>
      {intl.formatMessage(messages.ChangedField, {
        property: RenderProperty({ intl, log }),
        originalValue: renderFieldValue(log.oldValue, log.property),
        currentValue: renderFieldValue(log.newValue, log.property),
        b: value => <b>{value}</b>,
        i: value => <i>{value}</i>,
      })}
    </span>
  );
};

export default FieldChange;
